export default __webpack_public_path__ + "static/android-chrome-192x192.png";